import equals from "fast-deep-equal";
import React from "react";
import { withTranslation } from "react-i18next";
import MarkDownViewer from "../../../../components/markdownViewer/MarkDownViewer";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";

class InstructionsDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languages: [],
      selectedLanguage: { value: "", label: "" }
    };

    this.onHide = this.onHide.bind(this);
    this.onSelectLanguage = this.onSelectLanguage.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!equals(prevProps.studentExamination, this.props.studentExamination) || !equals(prevProps.t, this.props.t)) {
      if (!this.props.studentExamination) return;
      const languages = [];
      for (const key in this.props.studentExamination.examination.instructions) {
        if (
          this.props.studentExamination.examination.instructions[key].length > 0
        ) {
          languages.push({
            value: key,
            label: this.props.t(`Languages.${key}`)
          });
        }
      }
      this.setState({
        selectedLanguage: languages[0],
        languages: languages
      });
    }
  }

  onHide() {
    this.props.onHide();
  }

  onSelectLanguage(code) {
    this.setState({
      selectedLanguage: this.state.languages.filter(i => i.value === code)[0]
    });
  }

  render() {
    const { t } = this.props;
    let instructions = "";
    if (this.props.studentExamination && this.state.selectedLanguage) {
      instructions = (
        <MarkDownViewer
          lang={this.state.selectedLanguage.value}
          text={this.props.studentExamination.examination.instructions}
        />
      );
    }

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        title={t("ExaminationAccess.InstructionsDialog.Title")}
        body={(<div>
          <BaseSelect
            onChange={s => this.onSelectLanguage(s.value)}
            value={this.state.selectedLanguage}
            options={this.state.languages}
          />
          {instructions}
        </div>)} />
    );
  }
}

export default withTranslation()(InstructionsDialog);
